import Crypto from "crypto";
var NORMALIZE_EMAIL_REGEX = /\\+[^@] *@/g;
var hashEmail = function(email) {
    return Crypto.createHash("sha256").update(email.trim().toLowerCase().replace(NORMALIZE_EMAIL_REGEX, "@")).digest("hex");
};
export default hashEmail;
